import { makeHttpRequest } from "@/shared";

export const deleteExpenseType = async (id) => {
    return (
        await makeHttpRequest({
            url: `/expense/type/${id}`,
            method: "DELETE",
        })
    ).data;
};
